module.exports = __webpack_public_path__ + "img/vhr_sprite.49270734.png";